import { isValid as isDateTimeValid, format } from "date-fns";

import appConstants from "../../../../../../appConstants";

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString || !isDateTimeValid(dateTimeString)) {
    return "";
  }
  const date = format(dateTimeString, appConstants.DATETYPES.MONTHDATEYEAR.format);
  const time = format(dateTimeString, appConstants.DATETYPES.TIME.format);
  return `${date} | ${time}`;
};

const formatTime = (dateTimeString) => {
   if (!dateTimeString || !isDateTimeValid(dateTimeString)) {
     return "";
   }
   return format(dateTimeString, appConstants.DATETYPES.TIME.format);
}

export { formatDateTime, formatTime };
